import gql from 'graphql-tag';

export const UPDATE_ARTICLE_CATEGORY_MUTATION = gql`
  mutation UpdateArticleCategoryMutation($id: ID!, $input: CampaignArticleCategoryInput!) {
    updateArticleCategory(id: $id, input: $input) {
      articleCategory {
        id
        name
        description
        isDefault
        createdAt
      }
      errors
    }
  }
`;
